document.addEventListener('DOMContentLoaded', () => {
    initModernSliders();
});

document.addEventListener('shopify:section:load', () => {
    initModernSliders();
});

function initModernSliders() {
    // Find all slider containers
    const containers = document.querySelectorAll('.section-modern-slider .swiper-container');

    containers.forEach(container => {
        // Check if already initialized to prevent duplicates
        if (container.classList.contains('swiper-initialized')) return;

        // Get settings from data attributes (with defaults)
        const slidesDesktop = parseFloat(container.dataset.slidesDesktop) || 3;
        const slidesMobile = parseFloat(container.dataset.slidesMobile) || 1.2;
        const gapDesktop = parseInt(container.dataset.gapDesktop) || 30;
        const gapMobile = parseInt(container.dataset.gapMobile) || 20;

        new Swiper(container, {
            slidesPerView: slidesMobile,
            spaceBetween: gapMobile,
            loop: false,
            speed: 600,
            centeredSlides: false,
            watchSlidesProgress: true,
            navigation: {
                nextEl: container.querySelector('.swiper-button-next'),
                prevEl: container.querySelector('.swiper-button-prev'),
            },
            pagination: {
                el: container.querySelector('.swiper-pagination'),
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: Math.min(slidesDesktop, 2), // Tablet intermediate (opt)
                    spaceBetween: gapMobile
                },
                1024: {
                    slidesPerView: slidesDesktop,
                    spaceBetween: gapDesktop
                }
            }
        });
    });
}
